import React, { useState, useEffect, useCallback } from 'react';
import {
  Mic,
  Camera,
  History,
  FileText,
  Zap,
  Layout,
  FileCode,
  Monitor,
  Home
} from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import BackButton from '../../components/buttons/BackButton';
import HeaderNoAuth from '../../components/Header/HeaderNoAuth';
import './Guide.css';

// Import des tabs
import AccueilTab from './tabs/AccueilTab';
import DictaphoneTab from './tabs/DictaphoneTab';
import ScanAnnexeTab from './tabs/ScanAnnexeTab';
import HistoriqueTab from './tabs/HistoriqueTab';
import RapportsTab from './tabs/RapportsTab';
import DictaphoneLiveTab from './tabs/DictaphoneLiveTab';
import ModelesTab from './tabs/ModelesTab';
import TemplatesWordTab from './tabs/TemplatesWordTab';
import BureauTab from './tabs/BureauTab';

const tabs = [
  { id: 'accueil', label: 'Accueil', icon: Home, component: AccueilTab, className: 'tab-accueil' },
  { id: 'dictaphone', label: 'Dictaphone', icon: Mic, component: DictaphoneTab, className: 'tab-dictaphone' },
  { id: 'scan', label: 'Scan & Annexe', icon: Camera, component: ScanAnnexeTab, className: 'tab-scan' },
  { id: 'historique', label: 'Historique', icon: History, component: HistoriqueTab, className: 'tab-historique' },
  { id: 'rapports', label: 'Rapports', icon: FileText, component: RapportsTab, className: 'tab-rapports' },
  { id: 'live', label: 'Dictee Live', icon: Zap, component: DictaphoneLiveTab, className: 'tab-live' },
  { id: 'modeles', label: 'Modeles', icon: Layout, component: ModelesTab, className: 'tab-modeles' },
  { id: 'templates', label: 'Templates', icon: FileCode, component: TemplatesWordTab, className: 'tab-templates' },
  { id: 'bureau', label: 'Bureau', icon: Monitor, component: BureauTab, className: 'tab-bureau' },
];

function Guide() {
  const { isSubscribed, profile } = useAuth();
  const isAuthenticated = isSubscribed || profile;
  const [activeTab, setActiveTab] = useState('accueil');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Scroll to top when tab changes
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [activeTab]);

  const handleNavigateToTab = useCallback((tabId) => {
    setActiveTab(tabId);
  }, []);

  const ActiveTabComponent = tabs.find(tab => tab.id === activeTab)?.component || AccueilTab;

  return (
    <div className="guide-page">
      {!isAuthenticated && <HeaderNoAuth />}
      <BackButton to={isAuthenticated ? "/home" : "/"} />

      {/* Header with Tabs */}
      <header className="guide-header">
        <div className="header-content">
          <img src={`${process.env.PUBLIC_URL}/icon.png`} alt="voxia" className="logo" />
          <h1>Guide d'utilisation</h1>
        </div>
        <div className="guide-tabs-container">
          <div className="guide-tabs">
            {tabs.map(tab => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  className={`guide-tab-pill ${tab.className} ${activeTab === tab.id ? 'active' : ''}`}
                  onClick={() => setActiveTab(tab.id)}
                >
                  <Icon className="tab-icon" size={18} />
                  <span className="tab-text">{tab.label}</span>
                </button>
              );
            })}
          </div>
        </div>
      </header>

      <div className="settings-container">

        {/* Tab Content */}
        <div className="guide-content">
          <ActiveTabComponent onNavigateToTab={handleNavigateToTab} />
        </div>
      </div>
    </div>
  );
}

export default Guide;
